import React, { useState, useMemo, PropsWithChildren, useContext } from "react"

import { FullStory } from "@fullstory/browser"

import { UserContext } from "context/UserContext"
import { User } from "types/user"

export const UserProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const initialValue = useContext(UserContext)

  const [user, setUser] = useState<User | undefined>(initialValue.user)
  const [cid, setCid] = useState<string | undefined>(initialValue.cid)

  // ✅ Memoize context value to prevent unnecessary re-renders of consumers
  const contextValue = useMemo(
    () => ({ user, cid, setUser, setCid }),
    [user, cid, setUser, setCid]
  )

  if (user?.email) {
    FullStory('setIdentity', {
      uid: user.userId,
      properties: { email: user.email }
    })
  }

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  )
}
